var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { applyFilterWithManager, } from "../../index.js";
import { KlevuFetch, removeListFilters } from "../klevuFetch.js";
export function fetchNextPage({ response, func, ignoreLastPageUndefined = false, }) {
    var _a;
    const newFunc = func;
    if (!newFunc.queries) {
        return undefined;
    }
    const queryIndex = newFunc.queries.findIndex((q) => !q.isFallbackQuery);
    if (queryIndex === -1) {
        return undefined;
    }
    const prevQuery = newFunc.queries[queryIndex];
    const prevQueryResponse = (_a = response.queryResults) === null || _a === void 0 ? void 0 : _a.find((q) => q.id === prevQuery.id);
    if (!prevQueryResponse) {
        return undefined;
    }
    // no more pages
    if (!ignoreLastPageUndefined &&
        prevQueryResponse.meta.totalResultsFound <=
            prevQueryResponse.meta.offset + prevQueryResponse.meta.noOfResults) {
        return undefined;
    }
    const nextFunc = (override) => __awaiter(this, void 0, void 0, function* () {
        var _b, _c, _d, _e;
        if (!prevQuery.settings) {
            prevQuery.settings = {};
        }
        if ((override === null || override === void 0 ? void 0 : override.pageIndex) !== undefined) {
            prevQuery.settings.offset =
                prevQueryResponse.meta.noOfResults * override.pageIndex;
        }
        else {
            prevQuery.settings.offset =
                prevQueryResponse.meta.noOfResults + prevQueryResponse.meta.offset;
        }
        prevQuery.settings.limit = (_d = (_b = override === null || override === void 0 ? void 0 : override.limit) !== null && _b !== void 0 ? _b : (_c = prevQuery.settings) === null || _c === void 0 ? void 0 : _c.limit) !== null && _d !== void 0 ? _d : 5;
        // existance of prevQuery has checked in function before
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        newFunc.queries[queryIndex] = prevQuery;
        // add previous filters with manager
        if (override === null || override === void 0 ? void 0 : override.filterManager) {
            if (!newFunc.modifiers) {
                newFunc.modifiers = [];
            }
            newFunc.modifiers.push(applyFilterWithManager(override.filterManager));
        }
        newFunc.previousResultRecords = [
            ...((_e = func.previousResultRecords) !== null && _e !== void 0 ? _e : []),
            ...prevQueryResponse.records,
        ];
        return yield KlevuFetch(removeListFilters(newFunc, prevQueryResponse));
    });
    return nextFunc;
}
